import { render, staticRenderFns } from "./BeforeAfterComparison.vue?vue&type=template&id=c7e4ecc4&scoped=true"
import script from "./BeforeAfterComparison.vue?vue&type=script&lang=js"
export * from "./BeforeAfterComparison.vue?vue&type=script&lang=js"
import style0 from "./BeforeAfterComparison.vue?vue&type=style&index=0&id=c7e4ecc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e4ecc4",
  null
  
)

export default component.exports